import { render } from "./AdminCoursesEdit.vue?vue&type=template&id=13c534bb&scoped=true"
import script from "./AdminCoursesEdit.vue?vue&type=script&lang=js"
export * from "./AdminCoursesEdit.vue?vue&type=script&lang=js"

import "./AdminCoursesEdit.vue?vue&type=style&index=0&id=13c534bb&scoped=true&lang=css"

import exportComponent from "/var/www/boa/bo/frontend/boa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13c534bb"]])

export default __exports__